import { Button, Modal } from '@imprivata-cloud/components';
import { useTranslation } from 'react-i18next';
import { STEPS } from '@/setup/constants';
import { useNavigateToNextStep } from '@/setup/hooks/useNavigateToNextStep';
import QuestionSvg from '../../assets/icons/question.svg?react';
import './CannotCompleteSetupModal.less';

interface CannotCompleteSetupModalProps {
  isModalVisible: boolean;
  setModalVisible: (visible: boolean) => void;
}

const TRANSLATION = 'setup.cannot-complete';

const CannotCompleteSetupModal = ({
  isModalVisible,
  setModalVisible,
}: CannotCompleteSetupModalProps) => {
  const { t } = useTranslation();
  const navigateToNextStep = useNavigateToNextStep();

  return (
    <Modal
      open={isModalVisible}
      destroyOnHidden
      maskClosable={false}
      width={550}
      className="cannot-complete-setup-modal"
      centered
      okText={t(`${TRANSLATION}.button-primary`)}
      onOk={() => navigateToNextStep(STEPS.START)}
      onCancel={() => {
        setModalVisible(false);
      }}
      okButtonProps={{ 'data-testid': 'cannot-complete-btn-primary' }}
      // I cannot use the standard buttons
      // since onCancel is different from the secondary button action
      footer={(_, { OkBtn }) => (
        <>
          <Button
            label={t(`${TRANSLATION}.button-secondary`)}
            data-testid="cannot-complete-btn-secondary"
            onClick={() => {
              window.location.href = 'https://www.imprivata.com';
            }}
          />
          <OkBtn />
        </>
      )}
    >
      <QuestionSvg style={{ width: '4rem', margin: '.5rem' }} />
      <h2>{t(`${TRANSLATION}.text`)}</h2>
    </Modal>
  );
};

export default CannotCompleteSetupModal;
